import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { Controller, useForm } from "react-hook-form";
import styles from "./add-edit-coursework.module.css";
import CustomDrawer from "../../../../../../../../../common/custom-drawer/custom-drawer";
import CustomTextfield from "../../../../../../../../../common/input/custom-textfield/custom-textfield";
import CustomButton from "../../../../../../../../../common/custom-button/custom-button";
import { toast } from "react-toastify";
import { createCourseworkType, updateCourseworkType } from "../../../../../../../../../services/school_info";

const AddEditCoursework = ({ open, onClose, data }) => {
  const [loading, setLoading] = useState(false);
  const { control, getValues, reset, trigger } = useForm({
    mode: "onChange",
    defaultValues: { coursework_type_name: "" },
  });

  useEffect(() => {
    if (data?.id) {
      reset({ coursework_type_name: data?.coursework_type_name });
    } else {
      reset({ coursework_type_name: "" });
    }
  }, [data]);

  const handleSubmit = async () => {
    try {
      const isValid = await trigger();
      if (!isValid) {
        return;
      }

      const formValues = getValues();
      const payload = { coursework_type_name: formValues?.coursework_type_name };
      if (data?.id) await updateCourseworkType(data?.id, payload);
      else await createCourseworkType(payload);
      toast.success(`Coursework ${data?.id ? "edited" : "created"} successfully!`);
      handleClose();
    } catch (err) {
      toast.error(err?.data?.message || `Failed to ${data?.id ? "edit" : "create"} coursework`);
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <CustomDrawer
      title={`${data?.id ? 'Edit' : 'Add New'} Coursework Type`}
      open={open}
      onClose={handleClose}
      className={styles.drawer}
      footer={
        <div className={styles.footerWrapper}>
          <CustomButton
            onClick={handleClose}
            title="Back"
            variant="outlined"
            className={styles.footerBackButton}
          />
          <CustomButton
            title={`${data?.id ? "Edit" : "Add New"} Coursework`}
            size="large"
            onClick={handleSubmit}
          />
        </div>
      }
      width="40vw"
      drawerStyles={{ body: { padding: "50px" } }}
    >
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <Controller
            name="coursework_type_name"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomTextfield
                id="coursework_type_name"
                label="Coursework Type"
                showRequired
                labelColor="#171717"
                placeholder="Enter Coursework Type"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              />
            )}
          />
        </Col>
      </Row>
    </CustomDrawer>
  );
};

export default AddEditCoursework;
